import { CSSObject } from "@emotion/react";

export const useStyles = () =>
  ({
    checkboxLabel: {
      display: "inline-flex",
      alignItems: "center",
    },
    checkboxContent: {
      "& > span": {
        display: "block",
      },
    },
    infoIconCSS: {
      display: "inline-flex",
      height: "20px",
      verticalAlign: "middle",
      marginLeft: "8px",
    },
  } as CSSObject);
